import { ReactNode } from 'react';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useSharedStyles, useExpandedStyles } from './styles';

export type ExpandedSidebarGroupProps = {
  icon: ReactNode;
  label: ReactNode;
  children: ReactNode;
  isExpanded: boolean;
  hasActiveChild: boolean;
  onToggle: () => void;
};

export const ExpandedSidebarGroup = ({
  icon,
  label,
  children,
  isExpanded,
  hasActiveChild,
  onToggle,
}: ExpandedSidebarGroupProps) => {
  const sharedClasses = useSharedStyles();
  const expandedClasses = useExpandedStyles();

  // Build header class name for expanded mode
  const expandedHeaderClassName = clsx(
    sharedClasses.header,
    hasActiveChild && sharedClasses.headerActive,
  );

  return (
    <div className={expandedClasses.expandableRoot}>
      <ListItem button className={expandedHeaderClassName} onClick={onToggle}>
        <ListItemIcon className={sharedClasses.headerIcon}>{icon}</ListItemIcon>
        <ListItemText primary={label} className={sharedClasses.headerText} />
        <ExpandMoreIcon
          className={clsx(
            expandedClasses.expandIcon,
            isExpanded && expandedClasses.expandIconExpanded,
            'sidebar-expansion-icon',
          )}
          data-testid="ExpandMoreIcon"
        />
      </ListItem>

      <Collapse in={isExpanded} timeout="auto">
        <List component="div" className={expandedClasses.nestedList}>
          {children}
        </List>
      </Collapse>
    </div>
  );
};
